import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { ProfileModel } from '../models/profile.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';
 
@Injectable({
  providedIn: 'root',
})

export class ProducerPrivateResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private homeService:HomeService, private auth:AuthenticationService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    let id = route.paramMap.get('profileId');
    const item = await firstValueFrom(this.dataService.getProducerPrivate(id));
    if (item &&  Object.keys(item).length > 0) {
      const producer:ProfileModel = {
        key:id,
        private:item
      }
      return producer;
    } else { // id not found
        const user = await this.auth.getUser();
        if(user.role=='admin' || (user.role=='producer' && user.uid == id)){
          const newItem = <ProfileModel>{
            status:'new',
            private:{
              notifications:{
                newOrder:{
                  email:true,
                  app:true
                }
              }
            }
          };
          return newItem;
        }
        else{
          this.homeService.navigateToHome('unknown');
        }
    }
  }
}